import React from 'react'

import ReportTable from '../report_table'
import { formatReportDate } from '../helpers'

// port of cowebapp analytics/components/data_pulse/report_individual_table.js
const ReportTableIndividual = (props) => {

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.userReportData.breakdown)
  }

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []
    let tmp = props.tableData && props.tableData[0] && props.tableData[0].stats
      ? props.tableData[0].stats
      : props.tableData

    tmp.forEach(data => {
      const name = data.name?.billable || 0
      const email = data.email?.billable || 0
      const phone = data.phone?.billable || 0
      const total = name + email + phone

      if (total > 0) {
        tableData.push({
          date: data.date,
          name,
          email,
          phone,
          total
        })
      }
    })

    return tableData
  }

  const data = getTableData()
  const formatNumber = cell => cell ? Number(cell).toLocaleString() : '0'
  const colWidth = { width: '20%' }

  const columns = [
    {
      dataField: 'date',
      text: 'Date',
      formatter: dateFormatter,
      headerStyle: colWidth,
      style: colWidth
    },
    {
      dataField: 'total',
      text: 'Total Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    },
    {
      dataField: 'email',
      text: 'Email Validation Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'name',
      text: 'Name Validation Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right'
    },
    {
      dataField: 'phone',
      text: 'Phone Validation Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right'
    }
  ]

  return (
    <div className="report-table">
      <ReportTable
        keyField="date"
        data={data}
        columns={columns}
        wrapperClasses="table-report table-responsive"
        noDataIndication={noDataIndication}
      />
    </div>
  )
}

export default ReportTableIndividual
